module.exports = __webpack_public_path__ + "img/cont.7fff2181.jpg";